import { render, staticRenderFns } from "./FormFieldLabel.htm?vue&type=template&id=18aa56f6&scoped=true&"
import script from "./FormFieldLabel.ts?vue&type=script&lang=js&"
export * from "./FormFieldLabel.ts?vue&type=script&lang=js&"
import style0 from "./FormFieldLabel.scss?vue&type=style&index=0&id=18aa56f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa56f6",
  null
  
)

export default component.exports